export default {
  notAllEnvelopesWereCalculated: 'Nicht alle Grenzen wurden berechnet',
  someEnvelopesAreInvalid: 'Einige Grenzen sind ungültig',
  commentRequiredNotPassed: 'Jeder Umschlag, der nicht bestanden hat, erfordert einen Kommentar',
};
